// extracted by mini-css-extract-plugin
export default {"form":"FormContact_form__B9Ov3","formBody":"FormContact_formBody__52LYp"};